<ng-container
    #partnersIcons="icons"
    category="partners"
    lsIcons
>
    <ng-container
        *ngTemplateOutlet="partnersSwiper; context: {
            partners: partnersIcons.items$(),
        }"
    />
</ng-container>

<ng-template
    #partnersSwiper
    let-partners="partners"
>
    <div
        class="partners-slider__container"
        [class._swiper-is-end]="swiperIsEnd"
        [class._swiper-is-start]="swiperIsStart"
    >
        <swiper-container
            #swiperContainer
            init="false"
        >
            @for (icon of partners; track icon.alias) {
                <swiper-slide class="partners-slider__slide">
                    <a
                        class="partners-slider__item"
                        rel="dofollow"
                        target="_blank"
                        [href]="icon.url"
                    >
                        <picture class="partners-slider__picture">
                            <img
                                class="partners-slider__img"
                                height="50"
                                loading="lazy"
                                [alt]="icon.title"
                                [src]="icon.image"
                            >
                        </picture>
                    </a>
                </swiper-slide>
            }
        </swiper-container>
    </div>
</ng-template>
